var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseLiveDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseLiveDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP-CHAT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-group-expanded-video-copy-10",
    transform: "translate(-130.000000, -46.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.59438,12.3688483 L101.958451,16.0051801 L105.59438,19.6413396 C106.135207,20.1823764 106.135207,21.0587835 105.59438,21.5998203 C105.324156,21.8700458 104.969875,22.0052619 104.615766,22.0052619 C104.261072,22.0052619 103.906756,21.8702525 103.636739,21.5998203 L100.000017,17.9632473 L96.3635711,21.5997858 C96.0933818,21.8700113 95.7390662,22.0052275 95.3846472,22.0052275 C95.0303316,22.0052275 94.6762571,21.870218 94.4058266,21.5997858 C93.8650001,21.0589902 93.8650001,20.1825486 94.4058266,19.6413052 L98.0416526,16.0051456 L94.4056199,12.3688483 C93.8647934,11.8280183 93.8647934,10.9514044 94.4056199,10.4105744 C94.9463431,9.87015775 95.8224345,9.87015775 96.3633644,10.4105744 L99.9999828,14.0469062 L103.636326,10.4105744 C104.177359,9.87015775 105.053554,9.87015775 105.594173,10.4105744 C106.135207,10.9514044 106.135207,11.8280183 105.59438,12.3688483 Z",
    id: "icCloseLiveDesktop"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseLiveDesktop);
export default __webpack_public_path__ + "static/media/icCloseLiveDesktop.76d20d6f753c96315ead9e6792416247.svg";
export { ForwardRef as ReactComponent };